export const MAX_FILE_SIZE_IN_BYTES = 5 * 1024 * 1024 // 5 MB
export const allowedFileExtensions = [
  'pdf',
  'doc',
  'docx',
  'png',
  'jpg',
  'jpeg',
  'csv',
  'xml',
  'xls',
  'xlsx',
  'edi', // legacy format used in logistics
]
export const ALLOWED_FILE_EXTENSIONS_STR = allowedFileExtensions.join(',')

export function bytesToMegabytes(bytes: number): string {
  const mb = bytes / (1024 * 1024)
  return parseFloat(mb.toFixed(1)).toString()
}

export function getUploadErrorMessage(files: File[]) {
  if (files.length !== 1) return 'You must upload a single file at a time.'
  const ext = files[0].name.split('.').pop()?.toLowerCase()
  if (!ext || !allowedFileExtensions.includes(ext)) {
    return `File type not supported. Allowed types: ${ALLOWED_FILE_EXTENSIONS_STR}.`
  }
  if (files[0].size > MAX_FILE_SIZE_IN_BYTES) {
    const maxSizeInMB = bytesToMegabytes(MAX_FILE_SIZE_IN_BYTES)
    return `File size exceeds ${maxSizeInMB} MB.`
  }
  return ''
}
